import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { QueryOptions, QueryResult, ProcessResult } from '../components/common-dto/query.dto';
import { PostDto } from '../dto/post.dto';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PostService {
  constructor(
    private backend: BackendService,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getPosts(queryParams: QueryOptions): Observable<QueryResult<PostDto>> {
    return this.backend.getQuery<PostDto>('post', queryParams);
  }

  getPost(id: string): Observable<PostDto> {
    return this.backend.get<PostDto>(`post/${id}`);
  }

  createPost(post: PostDto): Observable<ProcessResult> {
    post.createdAt = undefined;
    post.updatedAt = undefined;
    return this.backend.post<ProcessResult>('post', post);
  }

  updatePost(id: string, post: PostDto): Observable<ProcessResult> {
    return this.backend.put<ProcessResult>(`post/${id}`, post);
  }

  deletePost(id: string): Observable<ProcessResult> {
    return this.backend.delete<ProcessResult>(`post/${id}`);
  }

  uploadPostMedia(postId: string, file: File): Observable<ProcessResult> {
    const formData = new FormData();
    formData.append('file', file);
    
    // For file uploads, we need to let the browser set the Content-Type header
    // with the boundary, so we'll use HttpClient directly
    const url = `${environment.apiUrl}/post/${postId}/media`;
    
    // Build headers manually (similar to BackendService.getHeaders)
    let headers = new HttpHeaders();
    
    const tenant = this.authService.getCurrentTenant();
    if (tenant?.id) {
      headers = headers.set('X-Tenant-ID', tenant.id);
    }
    
    const workspaceId = this.authService.getWorkspaceId();
    if (workspaceId) {
      headers = headers.set('X-Workspace-ID', workspaceId);
    }
    
    const token = this.authService.getToken();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    
    // Don't set Content-Type - let browser set it with boundary for multipart/form-data
    
    return this.http.post<ProcessResult>(url, formData, {
      headers: headers,
    });
  }
}

